/* eslint-disable no-bitwise */
export function uuidv4() {
  const uuidFormatString = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

  return uuidFormatString.replace(
    /[xy]/g,
    (c) => {
      const randChar = Math.random() * 16 | 0;

      const v = c === 'x'
        ? randChar
        : (randChar & 0x3 | 0x8);

      return v.toString(16);
    },
  );
}
